<template>
    <div class="trays-types">
        <div class="trays-types__header" @click="isOpen = !isOpen">
            <div class="trays-types__header-left">
                <div class="trays-types__image-wrapper">
                    <img
                            :src="link"
                            alt="Птица, полуфабрикаты, готовая еда"
                            class="trays-types__image"
                    />
                </div>
                <h2 class="trays-types__title">{{ headerTitle }}</h2>
            </div>
            <div class="trays-types__header-right">

                <svg class="trays-types__arrow"
                     :class="{ 'trays-types__arrow--open': isOpen }"
                     width="60" height="60" viewBox="0 0 60 60"
                     fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.5 25L30.002 36.45L42.5 25" stroke="#0A090B" stroke-width="2.5" stroke-linecap="round"
                          stroke-linejoin="round"/>
                </svg>
            </div>
        </div>

        <transition name="trays-slide">
            <div v-if="isOpen"
                 class="trays-types__content"
                 :class="{'trays-types__content--cols-2': Number(columns) === 2,'trays-types__content--cols-4': Number(columns) === 4 || !columns}">
                <div
                        v-for="(card, index) in cards"
                        :key="index"
                        class="trays-types__card"
                >
                    <h3 class="trays-types__card-title">{{ card.title }}</h3>

                    <div class="trays-types__details">
                        <div class="trays-types__row">
                            <span class="trays-types__label">Сварной слой:</span>
                            <span class="trays-types__value">{{ card.weldLayer }}</span>
                        </div>
                        <div class="trays-types__row">
                            <span class="trays-types__label">Барьерный слой:</span>
                            <span class="trays-types__value">{{ card.barrierLayer }}</span>
                        </div>
                        <div class="trays-types__row">
                            <span class="trays-types__label">Пленка:</span>
                            <span class="trays-types__value">{{ card.film }}</span>
                        </div>
                        <div class="trays-types__row">
                            <span class="trays-types__label">Моноупаковка:</span>
                            <span class="trays-types__value">{{ card.isMono }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: "traysTypes",
    props: {
        items: Array | Object | String,
        title: String,
        url: String,
        columns: String | Number, // переменная для количества столбцов
    },
    data() {
        return {
            isOpen: true,
            cards: this.items,
            headerTitle: this.title,
            link: this.url,
            /*cards: [
                {
                    title: 'Монолитный ПП',
                    weldLayer: '—',
                    barrierLayer: '—',
                    film: 'ПП',
                    isMono: 'Да'
                },
                {
                    title: 'Монолитный ПП + ПЭ',
                    weldLayer: 'ПЭ',
                    barrierLayer: '—',
                    film: 'ПЭ',
                    isMono: 'Нет'
                },
                {
                    title: 'Вспененный ПП (ВПП)',
                    weldLayer: '—',
                    barrierLayer: '—',
                    film: 'ПП',
                    isMono: 'Да'
                },
                {
                    title: 'ВПП + ПЭ',
                    weldLayer: 'ПЭ',
                    barrierLayer: '—',
                    film: 'ПП',
                    isMono: 'Нет'
                }
            ] */
        };
    }
}
</script>

<style scoped lang="scss">
.trays-types {
  background-color: #ffffff;
  border-radius: 32px;
  border: 1px solid #D2DCE5;
  overflow: hidden;
  margin-bottom: 32px;

  &__header {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #F5F5F7;
    cursor: pointer;
    user-select: none;
    padding-right: 32px;

    @media (max-width: 610px) {
      padding: 0;
    }
  }

  &__header-left {
    display: flex;
    align-items: center;
    gap: 20px;

    @media (max-width: 610px) {
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
    }
  }

  &__header-right {
    @media (max-width: 610px) {
      position: absolute;
      top: 24px;
      right: 24px;
    }

    & svg {
      @media (max-width: 610px) {
        width: 50px;
        height: 50px;
      }
    }
  }

  &__image-wrapper {
    max-width: 347px;
    max-height: 180px;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border-radius: 4px;

    @media (max-width: 1024px) {
      max-width: 240px;
      max-height: 130px;
    }

    @media (max-width: 425px) {
      max-width: 200px;

    }

  }

  &__image {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    border-top-right-radius: 1000px;
    border-bottom-right-radius: 1000px;
    flex-shrink: 0;
  }

  &__title {
    font-family: 'MuseoSansCyrl-500';
    font-weight: 400;
    font-size: 32px;
    line-height: 40px;
    letter-spacing: 0px;
    color: #212424;
    margin: 0;

    @media (max-width: 1440px) {
      font-size: 32px;
      line-height: 40px;
    }

    @media (max-width: 1024px) {
      font-size: 26px;
      line-height: 32px;
    }

    @media (max-width: 768px) {
      font-size: 24px;
      line-height: 32px;
    }

    @media (max-width: 610px) {
      padding: 0 24px 24px 24px;
    }

    @media (max-width: 425px) {
      font-size: 20px;
      line-height: 26px;
    }


  }

  &__arrow {
    transition: transform 0.3s ease;
    margin-right: 8px;

    &--open {
      transform: rotate(-180deg);
    }
  }

  &__content {
    display: grid;
    padding: 24px;

    @media (max-width: 425px) {
      padding: 0;
    }

    &--cols-4 {
      grid-template-columns: repeat(4, 1fr);

      @media (max-width: 1440px) {
        grid-template-columns: repeat(2, 1fr);
      }

      @media (max-width: 768px) {
        grid-template-columns: repeat(1, 1fr);
      }
    }

    &--cols-2 {
      grid-template-columns: repeat(2, 1fr);

      @media (max-width: 768px) {
        grid-template-columns: repeat(1, 1fr);
      }


    }
  }

  &__card {
    padding: 32px;
    border-right: 1px solid #D2DCE5;

    &:last-child {
      border-right: none;
    }

    @media (max-width: 1440px) {
      &:nth-child(2) {
        border-right: none;
      }

      &:nth-child(3), &:nth-child(4) {
        border-top: 1px solid #D2DCE5;

      }
    }

    @media (max-width: 768px) {
      border-right: none;
      border-top: 1px solid #D2DCE5;

      &:first-child {
        border-top: none;
      }
    }
  }

  &__card-title {
    font-family: 'RobotoMedium';
    font-weight: 500;
    font-size: 24px;
    line-height: 32px;
    letter-spacing: 0px;
    margin-bottom: 24px;

    @media (max-width: 425px) {
      font-size: 20px;
      line-height: 26px;
    }
  }

  &__details {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &__row {
    display: flex;
    gap: 5px;
    font-family: 'RobotoRegular';
    font-weight: 400;
    font-size: 24px;
    line-height: 32px;
    letter-spacing: 0px;

    @media (max-width: 425px) {
      font-size: 20px;
      line-height: 26px;
    }
  }

  &__label {
    color: #7F7D83;
  }

  &__value {
    color: #212424;
  }
}

.trays-slide-enter-active,
.trays-slide-leave-active {
  transition: max-height 0.3s ease, opacity 0.3s ease;
  max-height: 600px;
  overflow: hidden;
}

.trays-slide-enter,
.trays-slide-leave-to {
  max-height: 0;
  opacity: 0;
}
</style>
